<template>
  <footer class="content-container">
    <div class="socials">
      <a href="https://www.instagram.com/gyra.shop/" target="_blank">
        <img
          src="../../assets/images/social/instagram.png"
          alt="instagram"
          class="social"
        />
      </a>
      <a href="https://www.linkedin.com/company/gyraofficial" target="_blank">
        <img
          src="../../assets/images/social/linkedin.png"
          alt="linkedin"
          class="social"
        />
      </a>
    </div>
    <div class="footer-menu">
      <a @click="visitForBusiness">Our Mission</a>
      <a @click="visitJobs">About us</a>
      <a @click="visitAboutUs">For Retailers</a>
      <a>Contact us</a>
      <a
        href="https://docs.google.com/document/d/e/2PACX-1vQZHpRJyTggjZPwZQW_sw2FIbpsv20qMacrgoFXWhSlqhjCDIxMFqJGMD2ImQKVkGLNDLYcEEyRSpqO/pub"
        download="gyra_privacy_policy.pdf"
      >
        {{ "footer.titles.privacy_policy" | translate }}
      </a>
    </div>
    <img
      src="../../assets/images/gyra_banner/circle_white.png"
      alt="Logo"
      class="logo"
    />
    <span class="copyright">{{ "footer.titles.copyright" | translate }}</span>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  methods: {
    visitStoreInfo() {
      this.$router.push({ name: "StoresInfo" });
    },
    visitAboutUs() {
      this.$router.push({ name: "AboutPage" });
    },
    visitForBusiness() {
      this.$router.push({ name: "ForBusinessPage" });
    },
    visitJobs() {
      this.$router.push({ name: "JobPage" });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
footer {
  background-color: $brand-black;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $m-m 0;

  .logo {
    width: 3rem;
  }
}

.copyright,
.logo,
.footer-menu {
  margin-top: $m-s;
}

.copyright {
  color: $brand-gray-medium;
}

.footer-menu {
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  max-width: 30rem;
  flex-direction: column;

  @media (min-width: $breakpoint-sm) {
    flex-wrap: wrap;
    flex-direction: row;

    a {
      width: 33.3%;
    }
  }

  div:last-of-type {
    margin-top: $m-s;
  }

  a {
    color: $brand-white;
    padding: 0 1rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    white-space: nowrap;
  }
}

.socials {
  display: flex;

  a {
    height: 2rem;
    width: 2rem;
    display: flex;
    background-color: white;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }

  a:first-of-type {
    margin-right: 1rem;
  }
}

.social {
  height: 20px;
  width: 20px;
  background-position: center;
  color: $gyra-grey-dark;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    height: 22px;
    width: 22px;
  }
}
</style>
